import { render, staticRenderFns } from "./fromSafesTransfers.vue?vue&type=template&id=24c855ec&"
import script from "./fromSafesTransfers.vue?vue&type=script&lang=js&"
export * from "./fromSafesTransfers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports